import * as v from 'valibot';
import type { I18n } from '@lingui/core';
import { formatNumber } from '@worldcoo/ui/lib/utils';
import { DONATION_AMOUNT_LIMIT } from '@worldcoo/shared/core';
import { amountTooHighMessage, errorMessages } from './portal-messages';
import { isAboveCeilingUpFront } from './donation-ceiling';

/**
 * Shared by both entry points so the donor gets one message. `numberLocale` is the campaign's, which is not
 * always the language the portal is read in.
 */
export function donationAmountSchema(i18n: I18n, numberLocale: string, currencyCode: string) {
	return v.object({
		// A non-number fails `v.number()` and stops the pipe, so it never also reports "too high".
		amount: v.pipe(
			v.number(),
			v.check(
				(value) => !isAboveCeilingUpFront(value, currencyCode),
				() => i18n._(amountTooHighMessage(formatNumber(numberLocale, DONATION_AMOUNT_LIMIT, 0))),
			),
			v.check(
				(value) => value > 0,
				() => i18n._(errorMessages.amount),
			),
		),
	});
}
